import { faCircleUser, faPen } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import Arrow from "@/assets/icons/triangle-03.webp"
import { clsx } from "clsx"
import { useRef } from "react"
import ContainerSkeleton from "../../../components/skeletons/ContainerSkeleton"

const UserProfile = ({ userData, actionText = "", custNameCls, noArrow = false, toggleSidebar }) => {
  const arrowImgRef = useRef(null)

  const toggleSidebarMenu = () => {
    arrowImgRef.current.classList.toggle("rotate-180")
    toggleSidebar()
  }

  return (
    <>
      <div className="flex items-center">
        <FontAwesomeIcon icon={faCircleUser} size={actionText ? "4x" : "3x"} style={{ color: "#bc9c5c" }} />
        <div className="ml-2">
          <div>
            {userData ?
              <span className={clsx("text-[#bc9c5c] font-light font-agcasmlt", custNameCls)}>{userData.name}</span>
              :
              <ContainerSkeleton custH="h-[22px] lg:h-[30px]" custW="w-full" />
            }
            {!noArrow && (
              <>
                <button type="button" onClick={toggleSidebarMenu} className="text-[#bc9c5c] font-light font-agcasmlt text-xs hover:text-[#6d625a] cursor-pointer">
                  <img ref={arrowImgRef} width="13" src={Arrow} alt="" className="inline-block sm:hidden ml-1 -mt-1" />
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  )
}

export default UserProfile